var exports = {
  "U": "x804f0401--0ba89a--buttons",
  "x": "x804f0401--0ba89a--button",
};

module.exports = exports;
